import React from 'react'
import { observer } from 'mobx-react-lite';
import './index.scss';
import shareWhatapp from '@assets/img/share-whatsapp.svg';
import { useTranslation } from 'react-i18next';
import { useShareReplace } from '@commons/shareLink';
import { scroller } from 'react-scroll';
import RootStore from '@stores';
import { MGMShares } from '@interfaces/portal';

interface WhatsappProps {
    mgmShares: MGMShares,
    mgmCode: string
}
const WhatsappShare:React.FC<WhatsappProps> = observer((props)=> {
    // https://api.whatsapp.com/send?text=%e5%96%82%e5%96%82%ef%bd%9e%e3%80%8c%e5%8f%8b%e3%80%8d%e8%91%97%e6%95%b8%e5%91%80%ef%bc%81%e9%a6%99%e6%b8%af%e5%af%ac%e9%a0%bb%e6%8e%a8%e5%87%ba%e5%85%a8%e6%96%b0%e6%8e%a8%e8%96%a6%e7%8d%8e%e8%b3%9e%e8%a8%88%e5%8a%83%ef%bc%8c%e7%94%a8%e6%88%91%e6%8e%a8%e8%96%a6%e7%b7%a8%e8%99%9f%e3%80%8cRHKBNI78938%e3%80%8d%e6%88%90%e5%8a%9f%e7%99%bb%e8%a8%98%e6%8c%87%e5%ae%9a%e5%af%ac%e9%a0%bb%ef%b9%91%e6%b5%81%e5%8b%95%e9%80%9a%e8%a8%8a%e5%8f%8a%20OTT%20%e5%a8%9b%e6%a8%82%e6%9c%8d%e5%8b%99%e8%a8%88%e5%8a%83%ef%bc%8c%e5%8d%b3%e5%8f%af%e9%bd%8a%e9%bd%8a%e8%b3%ba%e5%85%b1%e9%ab%98%e9%81%94%20$1,900%20%e8%b3%ac%e9%a1%8d%e5%9b%9e%e8%b4%88%ef%bc%81%e6%9c%89%e5%95%b2%e8%a8%88%e5%8a%83%e4%bb%b2%e5%81%9a%e7%b7%8a%e8%b6%85%e6%8a%b5%e5%84%aa%e6%83%a0%ef%bc%8c%e4%bb%b2%e7%ad%89%ef%bc%9f%e7%ab%8b%e5%8d%b3%e8%a1%8c%e5%8b%95%ef%bc%9ahttps://r.hkbn.net//w/RHKBNI78938%20%e5%8f%97%e6%a2%9d%e6%ac%be%e5%8f%8a%e7%b4%b0%e5%89%87%e7%b4%84%e6%9d%9f%e3%80%82%20
    const {
        mgmShares,
        mgmCode
    } = props
    const {i18n} = useTranslation();

    const {
        portalContent
    } = RootStore.PortalStore;
    
    const { replaceShareMessage } = useShareReplace()
    /**
     * 
     * @returns todo
     * app msg link
     */
    const getShareMessageData = () => {
        // var msg = shareMessage[cmsDataIndex].data.facebookContent[props.state.languageCode];
        // msg = replaceShareMessage(msg, "facebook", props.state.languageCode, props.mgmCode);
        let msg = replaceShareMessage(props.mgmShares.imContent || '', "whatsapp", i18n.language === 'zh-HK' ? "tc" : "en", props.mgmCode);
        return msg;
    }
    
    
    const handleClickShareButton = async () => {

        if (props.mgmCode) {
            if (window &&
                window.navigator &&
                window.navigator.userAgent &&
                (window.navigator.userAgent.indexOf("MyHKBNApp;Android") > -1 ||
                window.navigator.userAgent.indexOf("MyHKBNApp;iOS") > -1)) {
                // support myHKBN In app browser to share
                var dsBridge = require("dsbridge");
                var params = {
                "type": "operation",
                "function": "share",
                "extraData": getShareMessageData()
                }
                dsBridge.call("nativeAsyncBridgeMessage", JSON.stringify(params), (callbackParam: any) => myHkbnCallback(callbackParam));
            } else {
                await getRedirectUrlRequest(props.mgmCode);
            }
        } else {
            scroller.scrollTo("account", {
                smooth: 'easeOutQuad',
                duration: 800,
            })
        }
    };

    const myHkbnCallback = (callbackParam: any) => { }
    const getRedirectUrlRequest = async (code: string) => {
        let jumpLang = i18n.language === 'zh-HK' ? 'tc' : 'en'
        let replaceLink = portalContent.mgmShares?.[`imContent${jumpLang === 'tc' ? 'Chi' : 'Eng'}`]
        let replacedText = replaceLink?.replace(/\{0\}/g, code);
        replacedText = replacedText?.replace(/\{1\}/g, `https://r.hkbn.net/w/${code}`)
        replacedText = replacedText && encodeURIComponent(replacedText);
        window.open(`https://api.whatsapp.com/send?text=${replacedText}`)
    };
    

    return (
        <div className='sharemsg-icon' onClick={handleClickShareButton}>
            <img src={shareWhatapp} alt="" />
        </div>
    )
})

export default WhatsappShare;